/**
 * Shared AtlasFormsClient wiring for both FormLookupField and FormLookupFieldTwoMode —
 * the actual "connected" data-fetching logic lived duplicated in ConnectedFormLookupField
 * (designer-components-react, dead code, zero real consumers) and inline inside
 * FormPickerComponent/FormSelect/FormLookupSelect before this consolidation. One copy now.
 */

import { AtlasFormsClient } from '@atlas-forms/client-js';
import type { FormDefinition } from '@atlas-forms/types-js';

// isNodeForm: false — same class of bug fixed in App Studio's own (separately duplicated)
// fetchForms copies: every ExecutionNode's design-time config panel is itself stored as a Form
// row, so an unfiltered search here would surface those instead of real, end-user-facing Forms
// this connected picker is meant to find.
export async function fetchForms(search?: string, page?: number): Promise<FormDefinition[]> {
  const client = AtlasFormsClient.getInstance();
  const res = await client.listForms({ search, page, pageSize: 20, isNodeForm: false });
  return res.success && res.data ? res.data.items : [];
}

export async function loadForm(formID: number): Promise<FormDefinition | undefined> {
  return AtlasFormsClient.getInstance().getFormDefinition(formID);
}
